<template>
  <div class="loading" v-show='visible'>
    <div class="loadwarp">
      <img alt="" src="../../assets/images/animate/1.gif">
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        visible: false
      }
    }
  }
</script>
<style>
  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10000000000;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .loadwarp {
    width: 0.6rem;
    height: 0.6rem;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -0.3rem;
    margin-left: -0.3rem;
  }

  .loadwarp > img {
    width: 100%;
    height: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/common/loading.vue